import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonAlignLeft
  from 'components/atoms/Editors/EditorMenuButtonAlignLeft/EditorMenuButtonAlignLeft.styles';

const EditorMenuButtonAlignLeft = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonAlignLeft');

  return <StyledEditorMenuButtonAlignLeft buttonRef={ref} {...innerProps} />
});

EditorMenuButtonAlignLeft.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonAlignLeft;
